import Vue from 'vue'
import user from '../api/user'
import code from '../code'
import router from '@/router'

const types = {
  CODE: 'CODE',
  ADDRESS: 'ADDRESS',
  ADDRESSOLD: 'ADDRESSOLD',
  COURSECATELEVEL: 'COURSECATELEVEL',
  TAGS: 'TAGS',
  TAGS2: 'TAGS2',
  USERINFO: 'USERINFO',
  CLEARLOGIN: 'CLEARLOGIN',
  BUREAU: 'BUREAU',
  TERM: 'TERM',
  TEABUREAUSETTING: 'TEABUREAUSETTING',
}

//省市区关联
const addressSort = function (address) {
  let provinceList = []
  let cityList = []
  let districtList = []
  //对省市区分类，放入不同的list里面
  address.map((item) => {
    if (item.level == 'province') {
      provinceList.push(item)
    } else if (item.level == 'city') {
      cityList.push(item)
    } else if (item.level == 'district') {
      districtList.push(item)
    }
  })

  //市区关联
  cityList.map((city) => {
    city.children = []
    districtList.map((district) => {
      if (city.id == district.parentId) {
        city.children.push(district)
      }
    })
  })

  //省市区加入关联
  provinceList.map((province) => {
    province.children = []
    cityList.map((city) => {
      if (province.id == city.parentId) {
        province.children.push(city)
      }
    })
  })

  return provinceList
}

const common = {
  state: {
    code: {}, //码表
    courseCateLevel: {},
    address: {}, //拼接之后的地址
    addressOld: {}, //数据库地址
    tags: [], //课程标签
    tags2: [], //课程方课程标签
    userInfo: null, //用户信息
    bureau: {}, //教育局信息
    term: [], //站点全部学期
    teaBureauSetting: [], // 是否允许定价的数组
  },
  getters: {
    userInfo: (state) => {
      return state.userInfo
    },

    courseType: () => {
      return code.sourceType
    },

    //性别
    gender: () => {
      return code.gender
    },

    //是否包含教材
    hasTextbook: () => {
      return code.course.hasTextbook
    },

    //年级范围
    getGradeScope: (state) => {
      if (!state.tags || !state.tags.length) {
        return []
      }
      return state.tags
        .filter((tags) => {
          return tags.tagGroup == '2'
        })
        .map((item) => {
          return {
            ...item,
            gradeId: item.id,
          }
        })
    },

    //课程分类
    getClassify: (state) => {
      return state.tags && state.tags.length > 0
        ? state.tags.filter((tags) => {
            return tags.tagGroup == '1'
          })
        : []
    },
    //课程方课程分类
    getClassify2: (state) => {
      return state.tags2 && state.tags2.length > 0
        ? state.tags2.filter((tags) => {
            return tags.tagGroup == '1'
          })
        : []
    },
    //课程方课程分类
    getClassify2: (state) => {
      return state.tags2 && state.tags2.length > 0
        ? state.tags2.filter((tags) => {
            return tags.tagGroup == '1'
          })
        : []
    },
  },
  actions: {
    getInit({ commit }) {
      return new Promise((resolve) => {
        let tempAddressOld = Vue.ls.get('addressOld')
        let tempAddress = Vue.ls.get('address')
        let tempCode = Vue.ls.get('code')
        let tempTags = Vue.ls.get('tags')
        let tempTags2 = Vue.ls.get('tags2')
        let tempLevel = Vue.ls.get('courseCateLevel')
        let term = Vue.ls.get('term')
        let termteaBureauSetting = Vue.ls.get('teaBureauSetting')
        if (
          !tempAddress ||
          !tempCode ||
          !tempAddressOld ||
          !tempTags ||
          !tempTags2 ||
          !tempLevel ||
          !term ||
          !termteaBureauSetting
        ) {
          user.init().then((res) => {
            //码表拼接
            tempAddress = addressSort(res.districts)
            tempAddressOld = res.districts
            tempCode = res.roles
            tempTags = res.tags
            tempTags2 = res.tags2
            tempLevel = res.courseCateLevel
            termteaBureauSetting = res.teaBureauSetting

            Vue.ls.set('code', tempCode)
            Vue.ls.set('address', tempAddress)
            Vue.ls.set('addressOld', tempAddressOld)
            Vue.ls.set('tags', tempTags)
            Vue.ls.set('tags2', tempTags2)
            Vue.ls.set('courseCateLevel', tempLevel)
            Vue.ls.set('term', res.term)
            Vue.ls.set('schoolGrade', res.schoolGrade)
            Vue.ls.set('teaBureauSetting', termteaBureauSetting)

            commit('CODE', tempCode)
            commit('ADDRESS', tempAddress)
            commit('ADDRESSOLD', tempAddressOld)
            commit('TAGS', tempTags)

            commit('TAGS2', tempTags2)

            commit('COURSECATELEVEL', tempLevel)
            commit('TERM', res.term)
            commit('TEABUREAUSETTING', termteaBureauSetting)
            resolve({
              code: tempCode,
              address: tempAddress,
              addressOld: tempAddressOld,
              tags: tempTags,
              tags2: tempTags2,
              courseCateLevel: tempLevel,
              term: res.term,
              teaBureauSetting: termteaBureauSetting,
              isSchoolProject: res? res.isSchoolProject : ''
            })
          })
        } else {
          resolve({
            code: tempCode,
            address: tempAddress,
            addressOld: tempAddressOld,
            tags: tempTags,
            tags2: tempTags2,
            courseCateLevel: tempLevel,
            term: term,
            teaBureauSetting: termteaBureauSetting,
            isSchoolProject: false
          })
          commit('CODE', tempCode)
          commit('ADDRESS', tempAddress)
          commit('ADDRESSOLD', tempAddressOld)
          commit('TAGS', tempTags)
          commit('TAGS2', tempTags2)
          commit('COURSECATELEVEL', tempLevel)
          commit('TERM', term)
          commit('TEABUREAUSETTING', termteaBureauSetting)
        }
      })
    },

    //获取用户信息
    getUserInfo({ getters, commit }) {
      return new Promise((resolve) => {
        let userInfo = getters.userInfo
        if (!userInfo) {
          user.getCurrentUser().then((res) => {
            commit('USERINFO', res.data)
            Vue.ls.set('bureauId', res.data.bureauId)
            Vue.ls.set('schoolId', res.data.schoolId)
            resolve(res.data)
          })
        } else {
          resolve(userInfo)
        }
      })
    },
  },
  mutations: {
    [types.CODE](state, params) {
      state.code = params
    },
    [types.ADDRESS](state, params) {
      state.address = params
    },
    [types.ADDRESSOLD](state, params) {
      state.addressOld = params
    },
    [types.TAGS](state, params) {
      state.tags = params
    },
    [types.TAGS2](state, params) {
      state.tags2 = params
    },
    [types.COURSECATELEVEL](state, params) {
      state.courseCateLevel = params
    },
    [types.USERINFO](state, params) {
      state.userInfo = params
    },
    [types.BUREAU](state, params) {
      state.bureau = params
    },
    [types.TERM](state, params) {
      state.term = params
    },
    [types.TEABUREAUSETTING](state, params) {
      state.teaBureauSetting = params
    },
    [types.CLEARLOGIN]() {
      this.commit('USERINFO', null)
      this.commit('SCHOOLID', '')
      this.commit('CODE', {})
      this.commit('ADDRESS', {})
      this.commit('ADDRESSOLD', {})
      this.commit('COURSECATELEVEL', {})
      this.commit('TAGS', [])
      this.commit('TAGS2', [])
      this.commit('TERM', [])
      this.commit('TEABUREAUSETTING', [])

      Vue.ls.clear('courseCateLevel')
      Vue.ls.clear('token')
      Vue.ls.clear('refreshToken')
      Vue.ls.clear('code')
      Vue.ls.clear('address')
      Vue.ls.clear('addressOld')
      Vue.ls.clear('tags')
      Vue.ls.clear('tags2')
      Vue.ls.clear('term')
      Vue.ls.clear('teaBureauSetting')
    },
  },
}

export default common
